.groupTitle {
    font-size: 15px;
    font-weight: 700;
    font-family: Hanken Grotesk;
    padding: 6px 0px 0px 0px;
    color: #727b8c;
    width: 100%;
}

.groupContainer {
    border-radius: 10px !important;
}

.horizLine {
    width: 100%;
    height: 1px;
    background-color: #eaecf0;
    margin: 4px 0px !important;
}
.groupLink {
    cursor: pointer;
    border-radius: 10px !important;
    font-weight: 400;
    font-size: 15px;
    font-family: Hanken Grotesk;
    color: black !important;
    padding: 6px 0px !important;
    margin: 2px 0px;

    &:hover {
        color: black !important;
        background-color: #e2edff !important;
    }
}

.groupLinkSelected {
    font-weight: 600 !important;
    background-color: #f1efe9 !important;
    color: black !important;
}

.hamburgerContainer {
    position: absolute !important;
    right: -15px;
    top: 25px;
    pointer-events: none;

    background-color: white;
    border-radius: 10px;
    border: 1px solid #e4e7ec;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
    width: 22px;
}
